import { render, staticRenderFns } from "./IconUserOutline.vue?vue&type=template&id=ff4491ba"
import script from "./IconUserOutline.vue?vue&type=script&lang=js"
export * from "./IconUserOutline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports